import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { VariableResultCommon, VariableResultMenu, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Menu16 } from '@makyoapp/makyo-icon/icon'
import { Button } from '@makyoapp/makyo-ui'

import { MenuSelectV2 } from '../Builder/MenuSelectV2'
import { VariableWrapper } from './VariableWrapper'

export default function VariableMenu({
  onChange,
}: {
  onChange: (value: VariableResultCommon | VariableResultMenu) => void
}) {
  const [show, setShow] = useBoolean(false)

  return (
    <VariableWrapper title={<Trans>Menu</Trans>} icon={<Menu16 />} show={show} setShow={setShow}>
      <VariableMenuBody
        onDone={onChange}
        value={{
          flag: VariableSelectFeatureFlag.Menu,
          id: uuid4(),
          value: '',
        }}
        setShow={setShow}
      />
    </VariableWrapper>
  )
}

export function VariableMenuBody({
  value,
  setShow,
  onDone,
}: {
  onDone: (value: VariableResultCommon | VariableResultMenu) => void
  value: VariableResultCommon | VariableResultMenu
  setShow: (next: boolean) => void
}) {
  const [menu, setMenu] = useState(value.value)
  return (
    <div className='flex-c flex-col'>
      <div className='px-2 w-full'>
        <MenuSelectV2 value={menu} onChange={setMenu} />
      </div>
      <div className='px-2 w-full'>
        <Button
          disabled={!Boolean(menu)}
          className='w-full'
          onClick={() => {
            if (menu) {
              onDone({
                id: value.id,
                flag: VariableSelectFeatureFlag.Menu,
                value: menu,
              })
            }
            setShow(false)
          }}
        >
          <Trans>Select</Trans>
        </Button>
      </div>
    </div>
  )
}
